
import PedidoService from "@/services/PedidoService";
import { format } from "date-fns";
import Vue from "vue";
import Component from "vue-class-component";
import TimeLine from "../../wmc/TimeLine.vue";

@Component({
  name: "AcompanhamentoModal",
  props: {},
  components: {
    TimeLine,
  },
})
export default class AcompanhamentoModal extends Vue {
  dialog = false;
  loading = false;
  nroPedidoAtual: number | null = null;
  pedido = {
    datahora_criado: null,
    datahora_pendente: null,
    datahora_emromaneio: null,
    datahora_faturamento: null,
    datahora_cancelamento: null,
  };

  get items() {
    return [
      {
        title: "Pedido Criado",
        icon: "mdi-text-box-outline",
        date: this.dateToHumanReadable(this.pedido?.datahora_criado as any),
        active: this.isCriado,
      },
      {
        title: "Pendente",
        icon: "mdi-text-box-search-outline",
        date: this.dateToHumanReadable(this.pedido?.datahora_pendente as any),
        active: this.isPendente,
      },
      {
        title: "Em Romaneio",
        icon: "mdi-package-variant-closed",
        date: this.dateToHumanReadable(this.pedido?.datahora_emromaneio as any),
        active: this.isEmRomaneio,
      },
      {
        title: "Faturado",
        icon: "mdi-file-document-check-outline",
        date: this.dateToHumanReadable(
          this.pedido?.datahora_faturamento as any
        ),
        active: this.isFaturado,
      },
      {
        title: "Cancelado",
        icon: "mdi-file-document-remove-outline",
        date: this.dateToHumanReadable(
          this.pedido?.datahora_cancelamento as any
        ),
        active: this.isCancelado,
      },
    ];
  }

  async loadProduto(nroPedido: number) {
    const pedido = await PedidoService.getAcompanhamento({
      nroPedido: nroPedido,
    });

    this.pedido = { ...this.pedido, ...pedido?.data };
  }

  async show(nroPedido: number) {
    this.dialog = true;
    this.nroPedidoAtual = nroPedido;
    this.loading = true;
    try {
      await this.loadProduto(nroPedido);
    } finally {
      this.loading = false;
    }
  }

  get isCriado() {
    return this.pedido?.datahora_criado &&
      !this.pedido?.datahora_pendente &&
      !this.pedido?.datahora_emromaneio &&
      !this.pedido?.datahora_faturamento &&
      !this.pedido?.datahora_cancelamento
      ? true
      : false;
  }

  get isPendente() {
    return this.pedido?.datahora_pendente &&
      !this.pedido?.datahora_emromaneio &&
      !this.pedido?.datahora_faturamento &&
      !this.pedido?.datahora_cancelamento
      ? true
      : false;
  }

  get isEmRomaneio() {
    return this.pedido?.datahora_emromaneio &&
      !this.pedido?.datahora_faturamento &&
      !this.pedido?.datahora_cancelamento
      ? true
      : false;
  }

  get isFaturado() {
    return !this.pedido?.datahora_cancelamento &&
      this.pedido?.datahora_faturamento
      ? true
      : false;
  }

  get isCancelado() {
    return this.pedido?.datahora_cancelamento ? true : false;
  }

  dateToHumanReadable(value: Date) {
    if (!value) return "";
    const date = new Date(value);
    return format(date, "yyyy-MM-dd HH:mm:ss");
  }
}
